<template>
  <footer class="footer-page ">
    <div class="g_width">
      <div class="g_d_flex g_flex_justify_space-between g_flex_align_center">
        <div>
          <img class="logo" alt="" src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/m2/fe-shyunc/logo.png">
          <!-- <div class="footer-page-link">
            <a href="">关于我们</a>
            <a href="">法律声明</a>
            <a href="">隐私条款</a>
            <router-link to="/contact">联系我们</router-link>
            <a href="">投诉举报</a>
          </div> -->
          <p class="footer-contact-number"><img src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dianhua-6.png" />服务专线 <span>029-86255016</span></p>
        </div>
        <img class="footer-customer-wechat" alt="" src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/m2/fe-shyunc/service_qrcode.png">
      </div>
    </div>
    <div class="footer-page-icp">
      ©2015-2017 &nbsp;陕西建工材料设备物流集团有限公司 All Rights Reserved
    </div>
  </footer>
</template>
<style lang="scss">
.footer-page {
  background-color: #fff;
  padding: 50px 0 0;
  border-top: 1px solid #dcdcdc;
  .logo {
    width:180px;
    height:33px
  }

  .footer-page-link {
    margin: 50px 0;
    a {
      font-size: 16px;
      font-weight: 400;
      color: #1d2129;
      line-height: 16px;
      margin-right: 44px;
      transition: color 0.35s;
      &:hover {
        color: #007dff;
      }
    }
  }
  .footer-contact-number {
    font-size: 14px;
    font-weight: 400;
    color: #1d2129;
    line-height: 20px;
    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-right: 10px;
    }
    span {
      color: #175eff;
      font-size: 27px;
      margin-left: 6px;
    }
  }
  .footer-customer-wechat{
    width: 110px;
    height: 110px;
    transition: .25s;
    &:hover{
        transform: scale(1.1);
    }
  }
  .footer-page-icp {
    margin: 100px 0 30px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #4d5968;
    line-height: 24px;
  }
}
</style>